var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 56,
    viewBox: "0 0 51 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.04764 55.9339C4.72223 55.9339 5.3631 55.8183 5.97026 55.5872C6.5774 55.356 7.21828 55.0421 7.89288 54.6456L47.2224 32.3776C48.639 31.5627 49.6228 30.8414 50.1738 30.2136C50.7246 29.5859 51 28.8315 51 27.9505C51 27.0695 50.7246 26.3151 50.1738 25.6874C49.6228 25.0596 48.639 24.3493 47.2224 23.5564L7.89288 1.25546C7.21828 0.881024 6.5774 0.578171 5.97026 0.346903C5.3631 0.115634 4.72223 0 4.04764 0C2.81086 0 1.82705 0.4295 1.09623 1.2885C0.365411 2.1475 0 3.29283 0 4.72451V51.1766C0 52.6081 0.365411 53.7589 1.09623 54.6291C1.82705 55.499 2.81086 55.9339 4.04764 55.9339Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.98c5bc2aacb4a19b26a9910bcb8a49d3.svg";
export { ForwardRef as ReactComponent };